import { buttonVariants, TableCell, TableRow } from '@folio/components';
import { formatDate } from '@folio/lib';
import type { ListChildBrokerageFirmsOutput } from 'korint-sdk';
import { useKorintProductConfig } from 'korint-sdk/react';
import { EyeIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface IntermediaryListRowProps {
  /**
   * The brokerage firm to display in the row.
   */
  brokerageFirm: ListChildBrokerageFirmsOutput['data'][number];
}

export function IntermediaryListRow({ brokerageFirm }: IntermediaryListRowProps) {
  const { t } = useTranslation();
  const { productsConfig } = useKorintProductConfig();
  const numberOfProducts = Object.keys(productsConfig).length;

  return (
    <TableRow key={brokerageFirm.id}>
      <TableCell>{brokerageFirm.companyInfo?.name}</TableCell>
      <TableCell>{formatDate(new Date(brokerageFirm.createdAt))}</TableCell>
      <TableCell>
        {numberOfProducts > 1 &&
          brokerageFirm.productIdsWithStatus.reduce(
            (acc, product) =>
              `${acc}${acc.length > 0 ? ',' : ''} ${t(`products.${product}.label`)}`,
            '',
          )}
      </TableCell>
      <TableCell>
        <Link
          to={`/brokerage-firm-list/${brokerageFirm.id}`}
          className={buttonVariants({ size: 'sm', variant: 'ghost' })}
        >
          {t('intermediaryTabs.viewLink')}
          <EyeIcon className="ml-2 h-4 w-4" />
        </Link>
      </TableCell>
    </TableRow>
  );
}
